import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Colab from '../images/colab.jpg'

const Collaborate = () => {

    return (
        <>
         <Wrap >
			<Box>
            <img className='img' src={Colab} alt="Logo"/>
         <Fade bottom>
				<ItemText>
					<Heading >Collaborate</Heading>
                     
                     <h2>Teamwork makes the dream work! Find team members to work on a project with, form your winning hackathon team, or practice mock interviewing and whiteboarding with others and score your dream job.</h2>
				</ItemText>
			</Fade>
			</Box>
         </Wrap>
        </>
    );

}

export default Collaborate;

const Heading = styled.div`
    font-size : 80px;
	color : green;
`

const Wrap = styled.div `
min-height:100vh;
    background-color: white;
	color:black;
    min-width:100vw;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
padding: 15vh;
text-align: flex-start;
`
const Box = styled.div `
color: black;

background-color: rgb(229, 245, 254)  ;
width: 100vw;
height: 80vh;
background-size: cover; /* set size to cover */
background-position: center; /* center the image */
background-repeat: no-repeat; /* dont repeat the background */

display: flex;
flex-direction: row; /* switch to vertical */
justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */

@media (max-width : 768px){
	flex-direction: column;
}

`